import { get, put, post } from '@api/request';

export const getPropertyChanges = async (
  { mobileService },
  authenticationToken,
  { changesetID, changesetPropertyID },
) => {
  const url = `${mobileService}/mobile/validation/changeset/${changesetID}/property/${changesetPropertyID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const approvePropertyChanges = async (
  { mobileService },
  authenticationToken,
  { pId },
) => {
  const url = `${mobileService}/mobile/validation/property/${pId}/approve`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const rejectPropertyChanges = async (
  { mobileService },
  authenticationToken,
  { pId, rejectedNotes },
) => {
  const url = `${mobileService}/mobile/validation/property/${pId}/reject`;
  const { body } = await put(authenticationToken, url, { rejectedNotes });
  return body;
};

export const setPropertyChangeMainImage = async (
  { mobileService },
  authenticationToken,
  { changesetID, changesetPropertyID, payload },
) => {
  const url = `${mobileService}/mobile/validation/changeset/${changesetID}/property/${changesetPropertyID}/mainimage`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export async function searchProperty(
  { mobileService },
  authenticationToken,
  { payload, page = 1, pageSize = 50 },
) {
  let url = `${mobileService}/mobile/propertysearch/search?sortField=pID&sortDirection=DESC`;
  if (page && pageSize) {
    url += `&page=${page}&pageSize=${pageSize}`;
  }
  const { body } = await post(authenticationToken, url, payload);
  return body;
}
